import { TTintService } from 'features/product-info/components/pdp-select-tint-color';

type TProps = {
  tintServices: TTintService[];
  color: string;
};

export const getIsTintServiceWithSelectedColorInServices = ({ tintServices, color }: TProps) => {
  return tintServices.some((service) => {
    return service.parameters.color === color;
  });
};
